import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import s from './findings.module.scss';

/** Which findings destination is currently mounted. */
export type FindingsScopeSide = 'repository' | 'pr';

export function FindingsScopeSwitch({
  activeScope,
  onRepository,
  onPullRequests,
}: {
  activeScope: FindingsScopeSide;
  onRepository: () => void;
  onPullRequests: () => void;
}) {
  return (
    <div className={s.prScopeSwitch} aria-label="Findings scope">
      <button
        type="button"
        className={s.prScopeButton}
        data-active={activeScope === 'repository' || undefined}
        onClick={onRepository}
      >
        Repository backlog
      </button>
      <button
        type="button"
        className={s.prScopeButton}
        data-active={activeScope === 'pr' || undefined}
        onClick={onPullRequests}
      >
        Pull requests
      </button>
    </div>
  );
}

export function FindingsPagination({
  currentPage,
  totalPages,
  pageStart,
  pageEnd,
  totalItems,
  itemLabel = 'finding',
  onPageChange,
}: {
  currentPage: number;
  totalPages: number;
  pageStart: number;
  pageEnd: number;
  totalItems: number;
  itemLabel?: string;
  onPageChange: (page: number) => void;
}) {
  if (totalItems === 0) return null;
  const previousDisabled = currentPage <= 1;
  const nextDisabled = currentPage >= totalPages;

  return (
    <nav className={s.paginationBar} aria-label="Findings pagination">
      <p className={s.paginationSummary}>
        Showing {pageStart}-{pageEnd} of {totalItems}{' '}
        {totalItems === 1 ? itemLabel : `${itemLabel}s`}
      </p>
      <div className={s.paginationControls}>
        <button
          type="button"
          className={s.paginationButton}
          disabled={previousDisabled}
          aria-label="Previous page"
          onClick={() => onPageChange(currentPage - 1)}
        >
          <CaretLeft size={13} />
          Previous
        </button>
        <span className={s.paginationPage}>
          Page {currentPage} of {totalPages}
        </span>
        <button
          type="button"
          className={s.paginationButton}
          disabled={nextDisabled}
          aria-label="Next page"
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
          <CaretRight size={13} />
        </button>
      </div>
    </nav>
  );
}
